import { render, staticRenderFns } from "./PopupDownloadGroup.vue?vue&type=template&id=629bb0ba&scoped=true&"
import script from "./PopupDownloadGroup.vue?vue&type=script&lang=js&"
export * from "./PopupDownloadGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629bb0ba",
  null
  
)

export default component.exports